export class StorageService {
  static async read(key: string): Promise<string> {
    const text: string = localStorage.getItem(key);
    if (text === '' || text === undefined || text === null || typeof text === 'undefined' || text === 'undefined') {
      console.log('LocalStorageService::read(' + key + ') - key not found!');
      return undefined;
    }
    return text;
  }

  static async readObject<T>(key: string): Promise<T> {
    const text = await this.read(key);
    if (!text) {
      return undefined;
    }
    let value: T;
    try {
      value = <T>JSON.parse(text);
    } catch (error) {
      console.log("LocalStorageService::readObject: can't convert string from local storage to object using JSON.parse(). Error: " + error);
      value = undefined;
    }

    return value;
  }

  static async save(key: string, text: string): Promise<void> {
    localStorage.setItem(key, text);
  }

  static async saveObject(key: string, value: any): Promise<void> {
    const text: string = JSON.stringify(value);
    await this.save(key, text);
  }

  static async delete(key: string): Promise<void> {
    localStorage.removeItem(key);
  }

  static async clear(): Promise<void> {
    localStorage.clear();
  }
}
